module.exports = __webpack_public_path__ + "img/appstore.7df6be7d.jpg";